"use client";
import React, { useState, useEffect } from 'react';
import Image from 'next/image';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Sample testimonials data - you can replace this with data from your API
  const testimonials = [
    {
      id: 1,
      name: 'أحمد محمد',
      role: 'مصمم واجهات مستخدم',
      company: 'شركة التقنية',
      avatar: 'https://i.pravatar.cc/150?img=1',
      quote: 'مجتمع فيجماوية غير حياتي المهنية تماماً. التعلم المستمر والتحديات ساعدتني على تطوير مهاراتي بشكل كبير.',
      rating: 5
    },
    {
      id: 2,
      name: 'سارة علي',
      role: 'مصممة تجربة مستخدم',
      company: 'استوديو التصميم',
      avatar: 'https://i.pravatar.cc/150?img=5',
      quote: 'أفضل مجتمع عربي للمصممين. المحتوى المميز والتفاعل مع الخبراء جعلني أطور نفسي بسرعة.',
      rating: 5
    },
    {
      id: 3,
      name: 'محمد خالد',
      role: 'مصمم UI/UX',
      company: 'شركة الإبداع',
      avatar: 'https://i.pravatar.cc/150?img=12',
      quote: 'التحديات والمشاريع المشتركة ساعدتني على بناء محفظة أعمال قوية. شكراً فيجماوية!',
      rating: 5
    },
    {
      id: 4,
      name: 'فاطمة حسن',
      role: 'مصممة منتجات رقمية',
      company: 'منصة التكنولوجيا',
      avatar: 'https://i.pravatar.cc/150?img=9',
      quote: 'المجتمع داعم جداً والملاحظات البناءة من الخبراء ساعدتني على تحسين أعمالي بشكل مستمر.',
      rating: 5
    },
    {
      id: 5,
      name: 'يوسف أحمد',
      role: 'مصمم واجهات تفاعلية',
      company: 'وكالة التصميم',
      avatar: 'https://i.pravatar.cc/150?img=15',
      quote: 'منصة رائعة للمصممين العرب. المحتوى التعليمي والجلسات الحية تضيف قيمة حقيقية.',
      rating: 5
    }
  ];

  // Auto-rotate testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 5000); // Change every 5 seconds

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <i
        key={i}
        className={`bi ${i < rating ? 'bi-star-fill' : 'bi-star'}`}
        style={{
          color: i < rating ? '#FFD52E' : '#ddd',
          fontSize: '1rem'
        }}
      />
    ));
  };

  return (
    <div id="testimonials" className="my-5 py-5 mx-auto col-12 col-md-12 col-xxl-12 fade-in-up">
      <div className="text-center mb-5">
        <h2 className="fw-bold mb-3" style={{ fontSize: 'clamp(1.75rem, 5vw, 2.25rem)' }}>
          <i className="bi bi-chat-quote-fill me-2" style={{ color: '#FFD52E' }}></i>
          ماذا يقول أعضاؤنا
        </h2>
        <p className="text-muted" style={{ fontSize: 'clamp(1rem, 3vw, 1.125rem)' }}>
          انضم إلى آلاف المصممين المميزين الذين يطورون مهاراتهم معنا
        </p>
      </div>

      <div className="row justify-content-center">
        <div className="col-12 col-md-10 col-lg-8">
          <div
            className="card border-0 shadow-lg position-relative overflow-hidden"
            style={{
              borderRadius: '24px',
              // background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 249, 250, 0.98) 100%)',
              minHeight: '350px'
            }}
          >
            {/* Quote Icon Background */}
            <div
              className="position-absolute"
              style={{
                top: '20px',
                right: '20px',
                opacity: 0.1,
                fontSize: '8rem',
                color: '#FFD52E',
                lineHeight: 1
              }}
            >
              <i className="bi bi-quote"></i>
            </div>

            <div className="card-body p-4 p-md-5 position-relative">
              {/* Testimonial Content */}
              <div className="text-center mb-4">
                {/* Stars Rating */}
                <div className="mb-3 d-flex justify-content-center gap-1">
                  {renderStars(testimonials[currentIndex].rating)}
                </div>

                {/* Quote */}
                <p
                  className="mb-4 fw-medium"
                  style={{
                    fontSize: 'clamp(1rem, 3vw, 1.25rem)',
                    lineHeight: '1.8',
                    color: '#333',
                    fontStyle: 'italic'
                  }}
                >
                  "{testimonials[currentIndex].quote}"
                </p>

                {/* Author Info */}
                <div className="d-flex flex-column align-items-center">
                  <div className="mb-3 position-relative">
                    <Image
                      src={testimonials[currentIndex].avatar}
                      alt={testimonials[currentIndex].name}
                      width={80}
                      height={80}
                      className="rounded-circle border-3 border-white shadow-sm"
                      style={{
                        objectFit: 'cover',
                        borderColor: '#FFD52E'
                      }}
                    />
                  </div>
                  <h5
                    className="fw-bold mb-1 text-dark"
                    style={{
                      fontSize: 'clamp(1.125rem, 3vw, 1.375rem)',
                      color: '#333'
                    }}
                  >
                    {testimonials[currentIndex].name}
                  </h5>
                  <p
                    className="text-muted mb-0"
                    style={{ fontSize: 'clamp(0.875rem, 2.5vw, 1rem)' }}
                  >
                    {testimonials[currentIndex].role}
                  </p>
                  {testimonials[currentIndex].company && (
                    <p
                      className="text-muted small"
                      style={{ fontSize: 'clamp(0.75rem, 2vw, 0.875rem)' }}
                    >
                      {testimonials[currentIndex].company}
                    </p>
                  )}
                </div>
              </div>

              {/* Navigation Controls */}
              <div className="d-flex justify-content-between align-items-center mt-4">
                {/* Previous Button */}
                <button
                  onClick={goToPrevious}
                  className="btn btn-outline-secondary rounded-circle p-2"
                  style={{
                    width: '45px',
                    height: '45px',
                    borderColor: '#FFD52E',
                    color: '#FFD52E',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#FFD52E';
                    e.target.style.color = '#000';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'transparent';
                    e.target.style.color = '#FFD52E';
                  }}
                  aria-label="Previous testimonial"
                >
                  <i className="bi bi-chevron-right" style={{ fontSize: '1.25rem' }}></i>
                </button>

                {/* Dots Indicator */}
                <div className="d-flex gap-2">
                  {testimonials.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => goToSlide(index)}
                      className="btn p-0 border-0"
                      style={{
                        width: index === currentIndex ? '30px' : '10px',
                        height: '10px',
                        borderRadius: '5px',
                        background: index === currentIndex ? '#FFD52E' : '#ddd',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer'
                      }}
                      aria-label={`Go to testimonial ${index + 1}`}
                    />
                  ))}
                </div>

                {/* Next Button */}
                <button
                  onClick={goToNext}
                  className="btn btn-outline-secondary rounded-circle p-2"
                  style={{
                    width: '45px',
                    height: '45px',
                    borderColor: '#FFD52E',
                    color: '#FFD52E',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = '#FFD52E';
                    e.target.style.color = '#000';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'transparent';
                    e.target.style.color = '#FFD52E';
                  }}
                  aria-label="Next testimonial"
                >
                  <i className="bi bi-chevron-left" style={{ fontSize: '1.25rem' }}></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Additional Testimonials Grid (Optional - shows on larger screens) */}
      {/* <div className="row g-3 mt-4 d-none d-md-flex">
        {testimonials.slice(0, 3).map((testimonial, index) => (
          <div key={testimonial.id} className="col-md-4">
            <div
              className="card border-0 shadow-sm h-100 p-3"
              style={{
                borderRadius: '16px',
                background: index === currentIndex 
                  ? 'linear-gradient(135deg, rgba(255, 213, 46, 0.1) 0%, rgba(255, 140, 0, 0.05) 100%)'
                  : '#fff',
                transition: 'all 0.3s ease',
                border: index === currentIndex ? '2px solid #FFD52E' : '1px solid #e9ecef'
              }}
            >
              <div className="d-flex align-items-start mb-3">
                <Image
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  width={50}
                  height={50}
                  className="rounded-circle me-3"
                  style={{ objectFit: 'cover' }}
                />
                <div className="flex-grow-1">
                  <h6 className="fw-bold mb-1" style={{ fontSize: '0.95rem' }}>
                    {testimonial.name}
                  </h6>
                  <p className="text-muted small mb-0">{testimonial.role}</p>
                </div>
                <div className="d-flex gap-1">
                  {renderStars(testimonial.rating)}
                </div>
              </div>
              <p
                className="text-muted small mb-0"
                style={{
                  fontSize: '0.875rem',
                  lineHeight: '1.6',
                  display: '-webkit-box',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden'
                }}
              >
                "{testimonial.quote}"
              </p>
            </div>
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default Testimonials;
